{
  "header": {
    "eyebrow": "Energie",
    "title": "ODA-bemetering",
    "description": "Slimme-meteraansluitingen uitgelezen via de onafhankelijke datadienst (ODA)."
  },
  "error": {
    "title": "Meetpunten konden niet worden geladen",
    "description": "De ODA-dienst reageerde niet. Probeer het later opnieuw."
  },
  "unavailable": {
    "title": "ODA is niet beschikbaar",
    "description": "De ODA-bemeteringsmodule is niet beschikbaar in deze omgeving."
  },
  "list": {
    "title": "Meetpunten",
    "count": "{{count}} meetpunt",
    "count_other": "{{count}} meetpunten",
    "searchPlaceholder": "Zoek EAN, meter of locatie…",
    "searchAria": "Zoek meetpunten",
    "filters": {
      "aria": "Meetpuntfilters",
      "group": "Groep",
      "groupChip": "{{name}} ({{count}})"
    },
    "columns": {
      "ean": "EAN",
      "location": "Locatie",
      "meter": "Meter",
      "lastData": "Laatste data",
      "messages": "Berichten"
    },
    "empty": {
      "title": "Geen meetpunten",
      "description": "Niets komt overeen met de huidige zoekopdracht of groepsfilter."
    }
  },
  "detail": {
    "eyebrow": "ODA-meetpunt",
    "noLocation": "Geen locatienaam",
    "notFound": {
      "title": "Meetpunt niet gevonden",
      "description": "Geen ODA-gegevens voor {{id}}.",
      "back": "Terug naar overzicht"
    },
    "info": {
      "title": "Aansluitgegevens",
      "connection": "Aansluiting",
      "meterId": "Meter",
      "location": "Locatie",
      "externalReference": "Referentie",
      "activity": "Activiteit",
      "firstSeen": "Eerst gezien",
      "lastSeen": "Laatst gezien",
      "totalMessages": "Totaal berichten",
      "capacity": "Capaciteit",
      "fuseType": "Zekeringtype",
      "fuseLimit": "Geschatte limiet",
      "safetyMargin": "Veiligheidsmarge"
    },
    "metered": {
      "title": "Meetdata",
      "daysTitle": "Dagelijkse energie",
      "chartTitle": "Kwartierwaarden",
      "chartAria": "Energie per kwartier voor de geselecteerde dagen",
      "registerAria": "Registerfilter",
      "register": {
        "both": "Beide",
        "consumption": "Verbruik",
        "production": "Productie"
      },
      "consumption": "verbruik",
      "production": "productie",
      "fuseCapacity": "Zekeringcapaciteit",
      "plotAria": "Plot {{date}}",
      "columns": {
        "date": "Datum",
        "consumption": "Verbruik",
        "production": "Productie"
      },
      "noDays": {
        "title": "Geen dagelijkse energie",
        "description": "Dit meetpunt heeft nog geen dagelijkse energiegegevens."
      },
      "noSelection": {
        "title": "Geen dag geselecteerd",
        "description": "Vink een dag aan in de lijst om de kwartierwaarden te plotten."
      },
      "loadFailed_one": "{{count}} geselecteerde dag kon niet worden geladen.",
      "loadFailed_other": "{{count}} geselecteerde dagen konden niet worden geladen."
    }
  }
}
